import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import img from "@/assets/fiabaday-piazza.jpg";
import { Calendar, MapPin, Trophy } from "lucide-react";

const FiabaDay = () => (
  <>
    <SEO
      title="FIABA Day — Giornata Nazionale Abbattimento Barriere"
      description="FIABA Day: Giornata Nazionale per l'Abbattimento delle Barriere Architettoniche, istituita nel 2023, si tiene a Roma la prima domenica di ottobre. Nel 2026 la XXIV edizione."
      path="/fiaba-day"
    />
    <PageHero
      eyebrow="Manifestazioni & FIABA Day"
      title="La Giornata Nazionale dell'accessibilità"
      subtitle="L'evento che più rappresenta il valore, la missione e la forza dell'Associazione."
    />
    <section className="section-padding">
      <div className="container-narrow grid lg:grid-cols-2 gap-12 items-center">
        <img src={img} alt="FIABA Day — Piazza con manifestazione e palco istituzionale" className="rounded-lg shadow-elegant" loading="lazy" />
        <div className="space-y-5 text-foreground/90 leading-relaxed">
          <p>FIABA, nel corso dell'anno, organizza e partecipa a numerose manifestazioni, tutte orientate al superamento di ogni barriera e al miglioramento della qualità della vita delle persone.</p>
          <p>L'evento principale organizzato da FIABA, in collaborazione con la <strong>Presidenza del Consiglio dei Ministri</strong>, è il <strong>FIABA Day – Giornata Nazionale per l'Abbattimento delle Barriere Architettoniche</strong>.</p>
          <p>La Giornata Nazionale è stata istituita nel 2023 con direttiva del Presidente del Consiglio dei Ministri e si tiene a Roma la <strong>prima domenica di ottobre</strong> di ogni anno.</p>
        </div>
      </div>

      <div className="container-narrow mt-16 grid sm:grid-cols-3 gap-5">
        {[
          { i: Calendar, t: "Quando", d: "Prima domenica di ottobre" },
          { i: MapPin, t: "Dove", d: "Roma — sede istituzionale" },
          { i: Trophy, t: "Edizione 2026", d: "XXIV edizione del FIABA Day" },
        ].map((c) => (
          <div key={c.t} className="bg-hero text-primary-foreground p-6 rounded-lg text-center">
            <c.i className="w-9 h-9 text-secondary mx-auto mb-3" />
            <p className="text-secondary font-semibold uppercase text-xs tracking-widest">{c.t}</p>
            <p className="font-serif text-xl font-bold mt-1">{c.d}</p>
          </div>
        ))}
      </div>

      {/* Video ufficiale dal sito fiaba.org */}
      <div className="container-narrow mt-16">
        <p className="uppercase tracking-widest text-secondary text-xs font-bold mb-3 text-center">Guarda il video</p>
        <h2 className="heading-md text-primary text-center mb-6">FIABA Day in un minuto</h2>
        <div className="relative aspect-video w-full overflow-hidden rounded-lg shadow-elegant border border-border">
          <iframe
            src="https://www.youtube-nocookie.com/embed/UqMDGouQ14k"
            title="Video ufficiale FIABA Day"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="absolute inset-0 h-full w-full"
          />
        </div>
      </div>
    </section>
  </>
);

export default FiabaDay;
